// extracted by mini-css-extract-plugin
export default {"paginationContainer":"list_paginationContainer__roAoB"};